import React from 'react';
import { Shield, ShieldCheck } from 'lucide-react';
import { platformEnterprise } from '../data/overview';

export const PlatformEnterprise: React.FC = () => (
  <section
    id="enterprise-infrastructure"
    className="platform-enterprise"
    aria-labelledby="platform-enterprise-title"
  >
    <div className="platform-enterprise__glow" aria-hidden />
    <div className="platform-enterprise__inner">
      <h2 id="platform-enterprise-title" className="platform-enterprise__title">
        {platformEnterprise.title}
      </h2>
      <div className="platform-enterprise__stats">
        {platformEnterprise.stats.map((stat) => (
          <article key={stat.label} className="platform-enterprise__stat">
            <span className="platform-enterprise__stat-value">{stat.value}</span>
            <span className="platform-enterprise__stat-label">{stat.label}</span>
          </article>
        ))}
      </div>
      <div className="platform-enterprise__security">
        <h3 className="platform-enterprise__security-heading">
          <span className="platform-enterprise__security-heading-icon" aria-hidden>
            <Shield className="platform-enterprise__security-heading-svg" strokeWidth={1.75} />
          </span>
          Security Features
        </h3>
        <div className="platform-enterprise__security-grid">
          {platformEnterprise.security.map((item) => (
            <div key={item} className="platform-enterprise__security-card">
              <ShieldCheck className="platform-enterprise__security-card-icon" strokeWidth={1.75} aria-hidden />
              <span className="platform-enterprise__security-card-text">{item}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
